export default "<h3>October 27, 2018</h3>\r\n<p>Update 0.41 fixes bugs and tweaks the difficulty of some races.</p>";